import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridModule } from '@progress/kendo-angular-grid';
import { RvrsCreateFromExistingComponent } from './rvrs-create-from-existing.component';

@NgModule({
  imports: [
    CommonModule,
    GridModule],
  declarations: [RvrsCreateFromExistingComponent],
  exports: [RvrsCreateFromExistingComponent],
  schemas:[ CUSTOM_ELEMENTS_SCHEMA ]
})
export class RvrsCreateFromExistingModule { }